module.exports = __webpack_public_path__ + "img/dock-leveller-no.4b173c74.svg";